import ErrorIcon from "@mui/icons-material/Error";

import { Heading, Placeholder } from "./tableStyles";

export interface TableInfoRowProps {
  textContent: string;
  error: boolean | null;
}

export function TableInfoRow({ textContent, error }: TableInfoRowProps) {
  return (
    <Placeholder
      justifyContent="center"
      alignItems="center"
      sx={{
        boxSizing: "border-box",
        gap: 1
      }}
    >
      {error && <ErrorIcon color="error" />}
      <Heading color={error ? "error" : "inherit"}>{textContent}</Heading>
    </Placeholder>
  );
}
